/**
 * The KHARMA token's face — the coin artwork, wherever a balance or a price is
 * shown.
 *
 * ── One image, every size ───────────────────────────────────────────────────
 * `/kharma.png` is the token's own artwork: a finished coin with its rim and a
 * transparent ground, so it sits on both themes without a second file. It is
 * 256px, which covers the largest place it is drawn (about 40px) at 3× with
 * room to spare; the 1024px master it was cut from is `frontend/assets/kharma.png`.
 * The games draw the same file through their `.coin` CSS, so the token looks
 * the same in the header, the shop and a mission tally.
 *
 * This used to be the brand mark struck on an amber disc, drawn in CSS, because
 * the token had no artwork of its own. It has now, and a credit people earn and
 * spend should look like one thing everywhere rather than like the site's logo.
 *
 * The component keeps the name `MarqCoin` — like the `marq` in the API paths and
 * the ledger, it is an internal identifier from the token's first name, and
 * renaming those would touch stored data and every caller for no visible gain.
 *
 * `aria-hidden` and an empty `alt` — the coin never carries the meaning on its
 * own. Whatever it sits beside says the number and the word KHARMA in text,
 * which is what a screen reader needs; an alt of "KHARMA coin" here would make
 * every balance announce itself twice.
 */
export default function MarqCoin({ className = 'h-5 w-5' }: { className?: string }) {
  return (
    // eslint-disable-next-line @next/next/no-img-element -- a 256px static coin drawn at ≤40px; next/image would add a request per size for nothing
    <img
      src="/kharma.png"
      alt=""
      aria-hidden
      draggable={false}
      className={`inline-block shrink-0 select-none rounded-full object-contain ${className}`}
    />
  );
}
